<template>
  <div>
    <ifac-page-size-select
      v-show="(transformedRowData || []).length > 0"
      v-model="pageSizeChoice"
      :allow-all="allowAll"
      @change="onPageSizeChanged"
    />
    <ag-grid-vue
      class="ag-theme-alpine"
      :pagination="true"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="transformedRowData"
      :gridOptions="gridOptions"
      :paginationPageSize="paginationPageSize"
      @gridReady="onGridReady"
      @cellClicked="onCellClicked"
      domLayout="autoHeight"
      @updateConflict="console.log('updateConflict', $event)"
    ></ag-grid-vue>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { AgGridVue } from 'ag-grid-vue';
import { resolvePageSize } from '@ifac/ui';
import GridMixin from '@/views/components/grids/GridMixin';
import { gridColumns, gridDefaultColDef } from '@/views/components/grids/awards/ReviewsGrid';
import YesNoCellRenderer from '@/views/areas/awards/reviews/partials/YesNoCellRenderer.vue';
import Reviews from '@/services/Api/Awards/Reviews';

export default {
  name: 'ReviewsTable',
  components: {
    AgGridVue,
    YesNoCellRenderer,
  },
  mixins: [GridMixin],
  props: {
    reviews: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      defaultColDef: gridDefaultColDef,
      columnDefs: [],
      transformedRowData: null,
      gridOptions: {
        suppressCellFocus: true,
        rowHeight: 70,
      },
    };
  },
  methods: {
    async onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.showLoadingOverlay();
      this.applyPageSize();
    },
    resolvePageSize() {
      return resolvePageSize(
        this.pageSizeChoice,
        (this.transformedRowData || []).length,
      );
    },
    onCellClicked({ column, data }) {
      const review = data;

      if (column.colId !== 'nominee') {
        return;
      }

      if (review.can.view === false) {
        return;
      }

      this.$router.push({
        name: 'ReviewsEdit',
        params: {
          review: review.id,
        },
      });
    },
    fetchReviewers() {
      this.reviews.forEach((review) => {
        const newRow = { ...review };

        const params = {
          nomination_id: review.nomination_id,
          relations: ['affiliate'],
        };

        Reviews.all(params).then((response) => {
          const reviews = response.data.data;

          newRow.reviews = reviews;

          reviews
            .filter((r) => r.is_reviewer === true)
            .forEach((reviewer, index) => {
              newRow[`reviewer_${index + 1}`] = reviewer;
            });

          const index = this.transformedRowData.findIndex(((r) => r.id === review.id));

          if (index >= 0) {
            this.transformedRowData.splice(index, 1, newRow);
          }
        });
      });
    },
    prepareGridData() {
      if (!this.reviews.length) {
        return;
      }

      this.columnDefs = gridColumns({
        conflictComponent: 'YesNoCellRenderer',
        maxReviews: this.reviews[0].nomination.reviews_limit,
      });

      if (this.reviews && this.reviews.length) {
        this.transformedRowData = this.reviews;
        this.rowData = this.reviews;
      }
    },
  },
  watch: {
    reviews: {
      handler() {
        this.prepareGridData();
        this.fetchReviewers();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
